<template>
    <div class="wrapper" v-if="data">
        <div class="half-circle" :style="{ backgroundColor: data.colour + ' !important'}">

        </div>
        <div class="icon-wrapper">
                <img :src="data.icon" style="width: 30px;" alt="icon-summary" />
            </div>
        <div class="content-summary">
            <p :style="{color: data.colour, fontWeight: 'bold'}" v-html="data.value">
            </p>
            <!-- <p :style="{color: data.colour, fontWeight: 'bold'}">
                &nbsp; {{ data.type == 'TOTAL' ? 'TO' : ''}}
            </p> -->

        </div><div class="caption-summary" v-html="data.title">
            </div>
    </div>
</template>
<style>
    .wrapper {
        width: 100%;
        height: 100%;
        border: solid 1px #F0F0F0;
        border-radius: 8px;
        position: relative;
    }
    .icon-wrapper {
        position: absolute;
        right: 10%;
        top: 10px;
    }
    .half-circle{
        width: 50%;
        right: 0px;
        position: absolute;
        height: 60px;
        opacity: 0.1;
        border-top-right-radius:8px;
        border-top-left-radius:0;
        border-bottom-right-radius:0;
        border-bottom-left-radius:100%;
        /* background: #FFF7E2; */
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .content-summary {
        margin-top: 60px;
        padding-left: 10px;
        padding-bottom: 15px;
        display:flex;
    }
    .caption-summary {
        margin-bottom: 20px;
        margin-right:5px;
        padding: 10px;
        color: #8E9196;
        font-size: clamp( 12px, 1.5vw, 1.7vh);
        word-break:inherit;
    }

    .content-summary p {
        font-size: clamp( 18px, 2.5vw, 3vh);
        margin-bottom: 0px;
    }
</style>
<script>
export default {
  name: 'summary-component',
  props: {
    data: {
      type: Object,
      default: {
        colour: '',
        icon: '',
        title: '',
        value: ''
      }
    }
  },
  mounted () {
    // console.log(this.data)
  }
}
</script>
